import React from 'react';
import styled from 'styled-components';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/store';


const DropdownProfile = () => {
  const { auth } = useAuthStore();
  const logout=useAuthStore(state=>state.logout);
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

   React.useEffect(() => {
    let timer;
    if (open) {
      timer = setTimeout(() => {
        setOpen(false);
      }, 2000); // 2 seconds
    }
    return () => clearTimeout(timer);
  }, [open]);

  return (
    <DropdownWrapper>
      <button className="profile-btn" onClick={() => setOpen(!open)}>
        <img src={auth.profile || '/default-profile.png'} alt="Profile" className="profile-img" />
        <span className="profile-name">{auth.firstName || auth.username}</span>
      </button>
      {open && (
         
        <div className="dropdown-content">
          {auth.role==='admin'?
          <div>
          <div className="dropdown-item" onClick={() => navigate(auth.role=='admin'? '/admindashboard':'/dashboard')}>Dashboard</div>     
            <div className="dropdown-item" onClick={() => navigate('/userlist')}>Users</div>
            <div className="dropdown-item" onClick={() => navigate('/adminorders')}>Orders</div>
            <div className="dropdown-item" onClick={() => navigate('/editproductform')}>Update Product</div>
            <div className="dropdown-item" onClick={() => navigate('/category')}>Create Category</div>
            <div className="dropdown-item" onClick={() => navigate('/subcategory')}>Create Subcategory</div>
            <div className="dropdown-item" onClick={() => navigate('/productform')}>Create Product</div>
            <div className="dropdown-item" onClick={logout}><NavLink to='/'>Logout</NavLink></div></div>
          :
          <div>
          <div className="dropdown-item" onClick={() => navigate(auth.role=='admin'? '/admindashboard':'/dashboard')}>Dashboard</div>     
            <div className="dropdown-item" onClick={() => navigate('/profile')}>Profile</div>
            <div className="dropdown-item" onClick={() => navigate('/orders')}>My Orders</div>
            <div className="dropdown-item" onClick={() => navigate('/UserAddressList')}>Address List</div>
            <div className="dropdown-item" onClick={() => navigate('/address')}>Create Address</div>
            <div className="dropdown-item" onClick={() => navigate('/reset')}>Reset Password</div> 
            <div className="dropdown-item" onClick={logout}><NavLink to='/'>Logout</NavLink></div> 
            </div>
        }
            
            
        </div>
      )}
    </DropdownWrapper>
  );
};


const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;

  .dropdown-content {
    position: absolute;
    top: 7.2rem;
    left: -1.5rem;
    background-color: white;
    min-width: 100px;
    box-shadow: 0px 8px 16px rgba(0,0,0,0.2);
    z-index: 1;
    border-radius: 0.5rem;
    overflow: hidden;
    
  }

  .dropdown-item {
    padding: 1rem;
    cursor: pointer;
    border-bottom: 1px solid #ddd;

    &:hover {
      background-color: #f1f1f1;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .profile-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    border: none;
    background: none;
  }

  .profile-img {
    width: 4.5rem;
    height: 4.5rem;
    border-radius: 50%;
  }

  .profile-name {
    font-weight: bold;
  }
`;



export default DropdownProfile;
